import { Component, HostBinding, Input } from '@angular/core';
import { BadgeComponent } from '../../badge/badge.component';

type CardGeneralColor = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
type CardGeneralSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type Data = {
  header: string;
  label: string;
};

@Component({
  selector: 'app-card-general',
  templateUrl: './card-general.component.html',
  styleUrls: ['./card-general.component.scss'],
  standalone: true,
  imports: [BadgeComponent],
})
export class CardGeneralComponent {
  @Input() color: CardGeneralColor = 'primary';
  @Input() size: CardGeneralSize = 'xs';
  @Input() data: Data;

  // sizes
  @HostBinding('class.header-label--xs') get isXs() {
    return this.size === 'xs';
  }
  @HostBinding('class.header-label--sm') get isSm() {
    return this.size === 'sm';
  }
  @HostBinding('class.header-label--md') get isMd() {
    return this.size === 'md';
  }
  @HostBinding('class.header-label--lg') get isLg() {
    return this.size === 'lg';
  }
  @HostBinding('class.header-label--xl') get isXl() {
    return this.size === 'xl';
  }
}
